import { atom } from 'recoil';
import { STORE_KEYS } from '../keys';

export const buyNowPayLaterStepsAtom = atom<number>({
  key: STORE_KEYS.BUY_NOW_PAY_LATER_STEPS,
  default: 0
});
